import script from "./etBtnCancel.vue?vue&type=script&lang=js"
export * from "./etBtnCancel.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__